import styled from 'styled-components'

export const ContainerGoCadastro = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`

export const ContainerAnamneseGrid = styled.div`
  margin-top: 16px;
`

export const AnamneseCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
  background: #fafafa;
`

export const AnamneseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
  margin-top: 12px;
`
